import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=39d09724&"
import script from "./contentDetail.vue?vue&type=script&lang=js&"
export * from "./contentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports